"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = fetch;
// eslint-disable-next-line @typescript-eslint/no-implied-eval,no-new-func
const _importDynamic = new Function("modulePath", "return import(modulePath)");
async function fetch(url, init) {
    const urlString = url instanceof URL ? url.href : url;
    if (!/^https?:\/\//i.test(urlString)) {
        throw new Error(`fetch only supports HTTP/HTTPS URLs, got: ${urlString}`);
    }
    if (typeof globalThis.fetch === "function") {
        return globalThis.fetch(urlString, init);
    }
    const { default: nodeFetch } = await _importDynamic("node-fetch");
    return nodeFetch(urlString, init);
}
//# sourceMappingURL=fetchHelper.js.map